import { SourceBasedExpression } from '../Expression.js';
export class IsEmptyExpression extends SourceBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource()
            .evaluate(visitor, localVariables);
        return Array.isArray(source) ? source.length === 0 : true;
    }
}
//# sourceMappingURL=IsEmptyExpression.js.map